// Generated by Argon compiler — do not edit by hand.
// CSR store output: reactive shared state with no runtime dependency.

const __argonSubs = new Map();

function __argonNotify(key) {
  for (const fn of __argonSubs.get(key) ?? []) fn();
}

export function argonSubscribe(key, fn) {
  let set = __argonSubs.get(key);
  if (!set) __argonSubs.set(key, set = new Set());
  set.add(fn);
  return () => {
    set.delete(fn);
    if (set.size === 0) __argonSubs.delete(key);
  };
}

export const sidebar = {};
let __argon_sidebar_status = "open";
Object.defineProperty(sidebar, "status", {
  enumerable: true,
  get() { return __argon_sidebar_status; },
  set(value) {
    if (Object.is(__argon_sidebar_status, value)) return;
    __argon_sidebar_status = value;
    __argonNotify("sidebar.status");
  },
});

let __argon_sidebar_activeThread = "";
Object.defineProperty(sidebar, "activeThread", {
  enumerable: true,
  get() { return __argon_sidebar_activeThread; },
  set(value) {
    if (Object.is(__argon_sidebar_activeThread, value)) return;
    __argon_sidebar_activeThread = value;
    __argonNotify("sidebar.activeThread");
  },
});

let __argon_sidebar_activeProject = "";
Object.defineProperty(sidebar, "activeProject", {
  enumerable: true,
  get() { return __argon_sidebar_activeProject; },
  set(value) {
    if (Object.is(__argon_sidebar_activeProject, value)) return;
    __argon_sidebar_activeProject = value;
    __argonNotify("sidebar.activeProject");
  },
});

let __argon_sidebar_activePage = "";
Object.defineProperty(sidebar, "activePage", {
  enumerable: true,
  get() { return __argon_sidebar_activePage; },
  set(value) {
    if (Object.is(__argon_sidebar_activePage, value)) return;
    __argon_sidebar_activePage = value;
    __argonNotify("sidebar.activePage");
  },
});

let __argon_sidebar_runningThreads = [];
Object.defineProperty(sidebar, "runningThreads", {
  enumerable: true,
  get() { return __argon_sidebar_runningThreads; },
  set(value) {
    if (Object.is(__argon_sidebar_runningThreads, value)) return;
    __argon_sidebar_runningThreads = value;
    __argonNotify("sidebar.runningThreads");
  },
});

export function argonSnapshot() {
  return {
    sidebar: { status: sidebar.status, activeThread: sidebar.activeThread, activeProject: sidebar.activeProject, activePage: sidebar.activePage, runningThreads: sidebar.runningThreads },
  };
}

export function argonHydrate(snapshot) {
  if (!snapshot) return;
  if (snapshot.sidebar) {
    if ("status" in snapshot.sidebar) sidebar.status = snapshot.sidebar.status;
    if ("activeThread" in snapshot.sidebar) sidebar.activeThread = snapshot.sidebar.activeThread;
    if ("activeProject" in snapshot.sidebar) sidebar.activeProject = snapshot.sidebar.activeProject;
    if ("activePage" in snapshot.sidebar) sidebar.activePage = snapshot.sidebar.activePage;
    if ("runningThreads" in snapshot.sidebar) sidebar.runningThreads = snapshot.sidebar.runningThreads;
  }
}

const __argonPayload = globalThis.document?.querySelector?.('script[type="application/json"][data-argon-stores]');
if (__argonPayload?.textContent) argonHydrate(JSON.parse(__argonPayload.textContent));
